"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitOddAndEven = void 0;
function splitOddAndEven(array) {
    // filter out the odd elements
    var odd = array.filter(function (_, i) { return i % 2 === 1; });
    // filter out the even elements
    var even = array.filter(function (_, i) { return i % 2 === 0; });
    var returnObject = {
        odd: odd,
        even: even,
    };
    return returnObject;
}
exports.splitOddAndEven = splitOddAndEven;
